import { render, staticRenderFns } from "./appointSuccess.vue?vue&type=template&id=e2cd7a36&scoped=true"
import script from "./appointSuccess.vue?vue&type=script&lang=js"
export * from "./appointSuccess.vue?vue&type=script&lang=js"
import style0 from "./appointSuccess.vue?vue&type=style&index=0&id=e2cd7a36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cd7a36",
  null
  
)

export default component.exports